import { DataTableRowHeight, DataTableSortDirection } from "../../../components/deprecated/DataTable/DataTable";
import { Utilities } from "../../../utils/utilities";
import { DataObjectFieldComparator } from "./DataObjects/DataObjectFieldComparator";
import { DataObjectHelper, DataObjectType } from "./DataObjects/DataObjectHelper";
import { ReadAccess } from "./AccessData";
import { FirebaseData } from "./FirebaseData";
import { LocalData } from "./LocalData";
import { FilterView } from "@src/components/deprecated/InlineFilters/InlineFilters";
import { FilterData } from "@src/components/deprecated/Filters/FilterData";

export class FirebaseViewData extends FirebaseData {
  title: string = "";
  filterGroup: string = "";
  /** @deprecated use rawFilters instead. Is not used anymore, so remove if no bugs */
  private filters: FilterData<any, any>[] = [];
  rawFilters: FilterData<any, any>[] = [];
  tableKeys: string[] = [];
  isTemplate: boolean = false;
  readAccess: ReadAccess = {};
  paginationSize?: number;
  rowHeight?: DataTableRowHeight;
  sortKey?: string;
  sortDirection?: DataTableSortDirection;

  override setup(data: any) {
    super.setup(data);

    this.title = typeof data.title === "string" ? data.title : "";
    this.filterGroup = typeof data.filterGroup === "string" ? data.filterGroup : "";
    this.tableKeys = Array.isArray(data.tableKeys) ? data.tableKeys : [];
    this.readAccess = Utilities.getReadAccess(data.readAccess);

    this.paginationSize = typeof data.paginationSize === "number" ? data.paginationSize : undefined;
    this.rowHeight = typeof data.rowHeight === "string" ? data.rowHeight : undefined;
    this.sortKey = typeof data.sortKey === "string" ? data.sortKey : undefined;
    this.sortDirection = typeof data.sortDirection === "string" ? data.sortDirection : undefined;
  }

  loadFilters(helper: DataObjectHelper<any>) {
    this.filters = [];
    this.rawFilters = [];

    if (typeof this.rawData.filters === "object") {
      for (const fieldKey of Object.keys(this.rawData.filters)) {
        const comparator = typeof this.rawData.filters[fieldKey].comparator === "string" ? this.rawData.filters[fieldKey].comparator : "";

        const dataField = helper.allFields().find((field) => field.key === fieldKey);

        if (dataField) {
          const storedValue = this.rawData.filters[fieldKey].data;
          let filterValue = undefined;
          if (Array.isArray(storedValue)) {
            if (storedValue.length === 1) {
              filterValue = storedValue[0] === "undefined" ? undefined : dataField.decode(storedValue[0]);
            } else {
              filterValue = storedValue.map((val) => dataField.decode(val));
            }
          } else {
            filterValue = storedValue === "undefined" ? undefined : dataField.decode(storedValue);
          }

          this.filters.push({
            comparator: comparator,
            value: filterValue,
            field: dataField,
          });

          this.rawFilters.push({
            comparator: comparator,
            value: storedValue,
            field: dataField,
          });
        }
      }
    }
  }

  toFilterView(): FilterView {
    return {
      id: this.id,
      title: this.title,
      activeFilters: this.rawFilters,
      originalFilters: this.rawFilters,
      tableKeys: this.tableKeys,
      firebaseView: this,
      paginationSize: this.paginationSize,
      rowHeight: this.rowHeight,
      lastUpdate: this.updatedBy?.date,
      sortKey: this.sortKey,
      sortDirection: this.sortDirection,
    };
  }

  isEditable() {
    return !this.isTemplate;
  }

  static instantiate(
    id: string,
    title: string,
    filters: FilterData<any, any>[],
    tableKeys: string[],
    paginationSize: number,
    rowHeight: DataTableRowHeight = "md"
  ): FirebaseViewData {
    const view = new FirebaseViewData(id, "", undefined);
    view.title = title;
    view.filters = filters;
    view.rawFilters = filters;
    view.tableKeys = tableKeys;
    view.isTemplate = true;
    view.rowHeight = rowHeight;
    view.paginationSize = paginationSize;
    return view;
  }
}
